import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ApiService } from '../api.service';
import { FormGroup, FormControl } from '@angular/forms';
import { IMMEvent } from 'src/app/model/imm-event/imm-event.model';

@Injectable({
  providedIn: 'root'
})
export class IMMEventService {

  constructor(private http: Http, private apiService: ApiService) { }

  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    eventName: new FormControl(''),
    startDate: new FormControl(''),
    endDate: new FormControl('')
  });

  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }

  findAll(): Promise<Array<IMMEvent>> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() })
    return this.http.get(this.apiDomain + "/ims/api/event/", { headers })
      .toPromise()
      .then(response => response.json() as IMMEvent[])
      .catch(this.handleError);
  }

  findById(eventId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() })
    return this.http.get(this.apiDomain + "/ims/api/event/" + eventId, { headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

}
